import axios from "axios";
import { createMockApi } from "@/lib/mockApi";
import { Analytics } from "@/lib/analyticsShim";

let BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const USE_MOCK = String(process.env.REACT_APP_USE_MOCK).toLowerCase() === "true";

// If no explicit BACKEND_URL is provided, default to the same origin
// at the `/_/backend` path. This prevents mixed-content errors when
// the frontend is served over HTTPS but the backend env points to HTTP.
if (!BACKEND_URL && typeof window !== "undefined") {
  BACKEND_URL = `${window.location.origin}/_/backend`;
}

export const API = `${BACKEND_URL.replace(/\/$/, "")}/api`;

const realApi = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach Authorization header when token is stored in localStorage (fallback for cross-domain cookie issues)
realApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("rm_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const api = USE_MOCK ? createMockApi() : realApi;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (detail?.msg) return detail.msg;
  return String(detail);
}
